// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"dN-z","carouselContainer":"eN-z"};